<template>
  <el-dialog
    class="rc-dialog"
    title="发送入学通知书"
    :visible.sync="importInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-dialog
      class="inner-dialog"
      title="预览"
      width="45%"
      :visible.sync="previewDiaShow"
      :close-on-click-modal="false"
      @close="closePreviewDialog"
      append-to-body
    >
      <iframe
        v-if="previewUrl"
        class="pdf-preview"
        :src="previewUrl"
        referrerpolicy="no-referrer"
      ></iframe>
      <div
        v-else
        class="empty"
        v-loading="loading"
        element-loading-text="获取预览PDF中.."
      >
        <div v-if="isError">获取预览PDF失败</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <butn @click="closePreviewDialog" title="取消"></butn>
        <butn v-if="previewUrl" btntype="primary" @click="send" title="发送"></butn>
      </div>
    </el-dialog>
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="140px"
    >
      <el-form-item>
        <a :href="downloadTemplate">
          <butn btntype="primary" title="模版示例word下载"></butn>
        </a>
      </el-form-item>
      <el-form-item
        required
        label="入学通知书模板："
        error="请上传入学通知书模板"
        :show-message="file == null"
      >
        <upload
          v-model="file"
          ref="removeFile"
          :showDefaultTip="false"
          :size="20"
          uploadAccept=".docx"
        >
          <template v-slot:customTip>
            <div>1、只能上传.docx文件，且不超过20Mb</div>
            <div style="color: red;">
              2、学员姓名位置，请用通配符{UserName}表示，系统会自动替换为学员姓名
            </div>
          </template>
        </upload>
      </el-form-item>
      <el-form-item label="短信通知：" class="m-t-10">
        <el-checkbox-group v-model="smsTypes">
          <el-checkbox
            v-for="(item, i) in smsTypeList"
            :label="item.paramKey"
            :key="i"
          >
            {{ item.paramValue }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="sms-tips">(不勾选则不发送短信通知)</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="previewPdf" title="预览"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { importAdmissionNoticeToSend, previewNotice } from "@/api/class";
import Upload from "@/components/upload/word";
import { admissionNoticeTemplate } from "@/assets/excel/index.js";

export default {
  components: { butn, Upload },
  props: {
    importInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: "导入",
        };
      },
    },
  },
  data() {
    return {
      classId: "",
      file: null,
      smsTypes: [],
      downloadTemplate: admissionNoticeTemplate,
      smsTypeList: [
        {
          paramKey: "1",
          paramValue: "学员所在单位联络员",
        },
        {
          paramKey: "2",
          paramValue: "学员本人",
        },
      ],
      previewDiaShow: false,
      previewUrl: null,
      loading: false,
      isError: false,
    };
  },
  methods: {
    previewPdf() {
      if (this.file == null) {
        this.$message.error("请上传入学通知书模板");
        return;
      } else {
        this.previewDiaShow = true;
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        previewNotice(formData)
          .then((res) => {
            this.loading = false;
            if (res && res.code == 0 && res.data && res.data.length) {
              this.previewUrl = res.data;
            } else {
              this.isError = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.isError = true;
          });
      }
    },
    closeDialog(flag = false) {
      this.$emit("close", flag);
    },
    send() {
      if (this.file != null) {
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("uuids", this.importInfo.uuids);
        formData.append("smsTypes", this.smsTypes);
        importAdmissionNoticeToSend(formData).then((res) => {
          if (res && res.code == 0) {
            this.$message.success(res.msg);
            this.closePreviewDialog();
            this.closeDialog(true);
          }
        });
      }
    },
    closePreviewDialog() {
      this.previewDiaShow = false;
      this.previewUrl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-tips {
  font-size: 12px;
  color: #606266;
}
.m-t-10 {
  margin-top: 10px;
}

.inner-dialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      padding: 0;
      min-height: 464px;
      max-height: calc(100vh - 100px);
    }
  }

  .pdf-preview {
    width: 100%;
    min-height: 720px;
    border: none;
  }

  .empty {
    display: flex;
    width: 100%;
    height: 464px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #909399;
  }
}
</style>
